import type { DataOption } from '@/common.types'
import type { FilterField } from '@/shared/components/filter/types'
import type { FilterSchema } from '@/shared/components/filter/validation'
import type { FieldConfigType } from '@/shared/components/query-builder/types'
import type { TreeNodeType } from '@/shared/lib/tree'

import React from 'react'
import { ListFilterIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import FiltersPopover from '@/shared/components/filter/FiltersPopover'
import { StateButton } from '@/shared/components/ui/state-button'

type Props = {
	filters: FilterSchema[]
	onChange(filters: FilterSchema[]): void
	side?: 'bottom' | 'top'
	align?: 'start' | 'end'
	fields?: FilterField[]
	options?: Record<string, DataOption[] | TreeNodeType[]>
	extendedFieldConfig?: FieldConfigType
	irremovableCount?: number
}

export default function BaseFilter({
	filters,
	fields,
	options,
	onChange,
	side = 'bottom',
	align = 'start',
	extendedFieldConfig,
	irremovableCount,
}: Props) {
	const { t } = useTranslation()

	return (
		<FiltersPopover
			fields={fields || []}
			filters={filters ?? []}
			dataChoices={options}
			onApply={onChange}
			extendedFieldConfig={extendedFieldConfig}
			irremovableCount={irremovableCount}
			side={side}
			align={align}
		>
			<StateButton onClear={() => onChange([])} active={!!filters.length}>
				<ListFilterIcon />
				{`${t('general_filter')}`} {filters.length ? `(${filters.length})` : ''}
			</StateButton>
		</FiltersPopover>
	)
}
